import React from 'react';
import * as Styled from './floor-attendance.styles';
import {Typography} from '@innowise-group/ui-kit';
import {useTranslation} from 'react-i18next';
import {AttendancePercentage} from '../attendance-percentage';
import {Can} from '@innowise-group/core';

export interface FloorAttendanceProps {
  isLoadingFirstPlan: boolean;
  freeWorkspacesCountFirstPlan: number;
  totalWorkspacesCountFirstPlan: number;
  attendancePercentFirstPlan: number;
  isShowSecondPlan: boolean;
  freeWorkspacesCountSecondPlan?: number;
  totalWorkspacesCountSecondPlan?: number;
  attendancePercentSecondPlan?: number;
  isLoadingSecondPlan?: boolean;
}

const FloorAttendanceStatsSkeleton: React.FC = () => (
  <>
    <Styled.StatsBlock>
      <Styled.SkeletonBone $width={120} $height={14} />
      <Styled.SkeletonBone $width={24} $height={16} $radius={4} />
    </Styled.StatsBlock>
    <Styled.StatsBlock>
      <Styled.SkeletonBone $width={160} $height={14} />
      <Styled.SkeletonBone $width={24} $height={16} $radius={4} />
    </Styled.StatsBlock>
    <Styled.StatsBlock>
      <Styled.SkeletonBone $width={180} $height={14} />
      <Styled.SkeletonBone $width={48} $height={28} $radius={7} />
    </Styled.StatsBlock>
  </>
);

const FloorAttendance: React.FC<FloorAttendanceProps> = ({
  isLoadingFirstPlan,
  freeWorkspacesCountFirstPlan,
  totalWorkspacesCountFirstPlan,
  attendancePercentFirstPlan,
  isShowSecondPlan,
  freeWorkspacesCountSecondPlan,
  totalWorkspacesCountSecondPlan,
  attendancePercentSecondPlan,
  isLoadingSecondPlan,
}) => {
  const {t} = useTranslation();

  return (
    <>
      <Can I="READ" a="FLOOR-ATTENDANCE">
        <Styled.FloorAttendanceContainer isShowSecondPlan={isShowSecondPlan} aria-busy={isLoadingFirstPlan}>
          {isLoadingFirstPlan ? (
            <FloorAttendanceStatsSkeleton />
          ) : (
            <>
              <Styled.StatsBlock>
                <Typography>{t('pages.floors.freeWorkspaces')}</Typography>
                <Typography style={{fontWeight: '700', fontSize: '16px'}}>{freeWorkspacesCountFirstPlan}</Typography>
              </Styled.StatsBlock>
              <Styled.StatsBlock>
                <Typography>{t('pages.floors.totalWorkspaces')}</Typography>
                <Typography style={{fontWeight: '700', fontSize: '16px'}}>{totalWorkspacesCountFirstPlan}</Typography>
              </Styled.StatsBlock>
              <Styled.StatsBlock>
                <AttendancePercentage attendancePercent={attendancePercentFirstPlan} attendanceType={'floor'} />
              </Styled.StatsBlock>
            </>
          )}
        </Styled.FloorAttendanceContainer>

        {isShowSecondPlan && (
          <Styled.FloorAttendanceContainer
            isShowSecondPlan={isShowSecondPlan}
            isSecondPlan
            aria-busy={Boolean(isLoadingSecondPlan)}
          >
            {isLoadingSecondPlan ? (
              <FloorAttendanceStatsSkeleton />
            ) : (
              <>
                <Styled.StatsBlock>
                  <Typography>{t('pages.floors.freeWorkspaces')}</Typography>
                  <Typography style={{fontWeight: '700', fontSize: '16px'}}>{freeWorkspacesCountSecondPlan}</Typography>
                </Styled.StatsBlock>
                <Styled.StatsBlock>
                  <Typography>{t('pages.floors.totalWorkspaces')}</Typography>
                  <Typography style={{fontWeight: '700', fontSize: '16px'}}>
                    {totalWorkspacesCountSecondPlan}
                  </Typography>
                </Styled.StatsBlock>
                <Styled.StatsBlock>
                  <AttendancePercentage attendancePercent={attendancePercentSecondPlan} attendanceType={'floor'} />
                </Styled.StatsBlock>
              </>
            )}
          </Styled.FloorAttendanceContainer>
        )}
      </Can>
    </>
  );
};

export default React.memo(FloorAttendance);
